import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-edit-static-content',
  templateUrl: './edit-static-content.component.html'
})
export class EditStaticContentComponent implements OnInit, AfterViewInit {
  editorValue: any;
  staticContentData: any;
  staticId: any;
  staticContentForm: FormGroup | any;
  description: any;
  title: any;
  appType: any;

  constructor(public mainService: MainService, private activatedRoute: ActivatedRoute,
    private router: Router) {
    this.activatedRoute.params.subscribe((res) => {
      this.staticId = res.id;
      if (this.staticId == ':id') {
        this.appType = "THERAPIST";
      } else {
        this.appType = "PATIENT";
      }

    });
    this.activatedRoute.queryParams.subscribe((res: any) => {
      if (Object.keys(res).length != 0)
        if (res && res != '' && res != undefined) {
          const parseData = JSON.parse(res.value);
          this.staticId = parseData.type;
          this.appType = parseData.therapist;
        }

    });
  }

  ngOnInit() {
    this.staticContentList();
  }

  ngAfterViewInit() {
    this.staticContentList();
  }

  staticContentList() {
    var url;
    if (this.appType && this.appType == 'THERAPIST') {
      url = ApiUrls.viewStaticContent + `?appType=THERAPIST` + `&Type=${this.staticId}`
    }
    else {
      url = ApiUrls.viewStaticContent + `?Type=${this.staticId}`
    }
    this.mainService.showSpinner();

    this.mainService.getApi(url, 0).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.staticContentData = res.result ? res.result : '';
        this.title = this.staticContentData.title;

        setTimeout(() => {
          this.description = this.staticContentData.description
          this.mainService.hideSpinner();
        }, 1000);

      } else {
        this.staticContentData = res.result ? res.result : ''
        this.mainService.hideSpinner();
        this.mainService.errorToast(res.responseMessage)
      }
    })
  }

  editStatic() {
    const data = {
      Type: this.staticId,
      title: this.title,
      description: this.description
    }
    this.mainService.showSpinner();
    this.mainService.putApi(ApiUrls.editStaticContent + `?appType=${this.appType}`, data, 0).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.mainService.hideSpinner();
        this.router.navigate(['static-content'])
      } else {
        this.mainService.hideSpinner();
        this.mainService.errorToast(res.responseMessage)
      }
    })
  }

}
